import { render, staticRenderFns } from "./IconQuizset.vue?vue&type=template&id=516f39b4&"
import script from "./IconQuizset.vue?vue&type=script&lang=js&"
export * from "./IconQuizset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports